import { useIsPaywallCustomizationPhase2 } from "@/react/hooks/useIsPaywallCustomizationPhase2";

interface UseCheckoutTabProps {
  disabled: boolean;
  label: string;
}

export const useCheckoutTab = ({ label, disabled }: UseCheckoutTabProps) => {
  const isPhase2Enabled = useIsPaywallCustomizationPhase2();

  if (isPhase2Enabled) {
    return { label, disabled };
  }

  return null;
};
